import { ThemeEvents, CartUpdatedEvent } from '@theme/events';

const money = (cents) => new Intl.NumberFormat('fr-FR', {
  style: 'currency',
  currency: 'EUR',
}).format(Number(cents) / 100);

function getUpsell(root) {
  const json = root.querySelector('[data-zn-upsell-variants]');
  if (!json) return null;
  try {
    return JSON.parse(json.textContent);
  } catch (error) {
    console.error('Zenniro upsell: variantes invalides', error);
    return null;
  }
}

function updateUpsell(root) {
  const variants = getUpsell(root);
  if (!variants) return;
  const choices = [...root.querySelectorAll('[data-zn-upsell-option]')]
    .sort((a, b) => Number(a.dataset.znUpsellOption) - Number(b.dataset.znUpsellOption))
    .map((select) => select.value);
  const variant = variants.find((candidate) =>
    candidate.options.every((value, index) => value === choices[index]),
  );
  const button = root.querySelector('[data-zn-upsell-add]');
  const price = root.querySelector('[data-zn-upsell-price]');
  if (!button) return;
  button.disabled = !variant?.available;
  button.dataset.variantId = variant?.id || '';
  button.textContent = variant?.available ? 'Ajouter au panier' : 'Indisponible';
  if (variant && price) price.textContent = money(variant.price);
}

async function addUpsell(button) {
  const root = button.closest('[data-zn-cart-upsell]');
  const drawer = button.closest('cart-drawer');
  const errorNode = root?.querySelector('[data-zn-upsell-error]');
  if (!root || !drawer || !button.dataset.variantId) return;

  button.disabled = true;
  button.textContent = 'Ajout en cours…';
  if (errorNode) errorNode.hidden = true;

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(button.dataset.variantId), quantity: 1 }],
        sections: [drawer.dataset.sectionId, 'auto-gifts'].join(','),
        sections_url: window.location.pathname,
      }),
    });
    const data = await response.json();
    if (!response.ok || data.status) throw new Error(data.description || 'Ajout impossible.');
    const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((res) => res.json());
    document.dispatchEvent(new CartUpdatedEvent({}, {
      itemCount: cart.item_count,
      source: 'zenniro-cart-upsell',
      sections: data.sections,
    }));
  } catch (error) {
    button.disabled = false;
    button.textContent = 'Ajouter au panier';
    if (errorNode) {
      errorNode.textContent = error.message || 'Une erreur est survenue. Réessayez.';
      errorNode.hidden = false;
    }
  }
}

document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-zn-upsell-option]');
  if (select) updateUpsell(select.closest('[data-zn-cart-upsell]'));
});

document.addEventListener('click', (event) => {
  const addButton = event.target.closest('[data-zn-upsell-add]');
  if (addButton) {
    event.preventDefault();
    addUpsell(addButton);
    return;
  }

  const cartLink = event.target.closest('a[href]');
  if (!cartLink) return;
  const url = new URL(cartLink.href, window.location.origin);
  if (url.origin === window.location.origin && url.pathname.replace(/\/$/, '') === '/cart') {
    event.preventDefault();
    document.dispatchEvent(new Event(ThemeEvents.cartOpen));
  }
});

if (window.location.pathname.replace(/\/$/, '') === '/cart') {
  window.location.replace('/?open_cart=1');
} else if (new URLSearchParams(window.location.search).has('open_cart')) {
  window.addEventListener('DOMContentLoaded', () => {
    document.dispatchEvent(new Event(ThemeEvents.cartOpen));
    const url = new URL(window.location.href);
    url.searchParams.delete('open_cart');
    window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
  }, { once: true });
}
